export default __webpack_public_path__ + "img/undo.83e8ee8b.svg";